import { render, staticRenderFns } from "./detailsMessageSendParent.vue?vue&type=template&id=51fc60b3&"
import script from "./detailsMessageSendParent.vue?vue&type=script&lang=js&"
export * from "./detailsMessageSendParent.vue?vue&type=script&lang=js&"
import style0 from "./detailsMessageSendParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports